import type { SearchData } from '@silvertours/common-landingpages-view';

const makeIslandSearchData = (query: string, cityCode?: string): SearchData =>
  ({
    location: {
      cityCode,
      displayName: query,
      type: 'city',
      query,
    },
    prefilterQuery: '',
    type: 'legacy',
  }) as SearchData;

export const ISLAND_STAGE_SEARCH_DATA: Record<string, SearchData> = {
  'adv/mietwagen-mallorca': makeIslandSearchData('Mallorca', 'PMI'),
  'adv/mietwagen-sardinien': makeIslandSearchData('Sardinien', 'OLB'),
  'adv/mietwagen-sizilien': makeIslandSearchData('Sizilien', 'CTA'),
  'mietwagen-mallorca': makeIslandSearchData('Mallorca', 'PMI'),
  'mietwagen-kreta': makeIslandSearchData('Kreta', 'HER'),
  'mietwagen-madeira': makeIslandSearchData('Madeira', 'FNC'),
  'mietwagen-fuerteventura': makeIslandSearchData('Fuerteventura', 'FUE'),
  'mietwagen-sardinien': makeIslandSearchData('Sardinien', 'OLB'),
  'mietwagen-teneriffa': makeIslandSearchData('Teneriffa', 'TFS'),
  'mietwagen-gran-canaria': makeIslandSearchData(
    'Gran Canaria, Spanien',
    'LPA',
  ),
  'mietwagen-rhodos': makeIslandSearchData('Rhodos', 'RHO'),
  'mietwagen-korfu': makeIslandSearchData('Korfu', 'CFU'),
  'mietwagen-sizilien': makeIslandSearchData('Sizilien', 'CTA'),
  'mietwagen-lanzarote': makeIslandSearchData('Lanzarote', 'ACE'),
  'mietwagen-ibiza': makeIslandSearchData('Ibiza', 'IBZ'),
  'mietwagen-kos': makeIslandSearchData('Kos', 'KGS'),
  'mietwagen-zakynthos': makeIslandSearchData('Zakynthos', 'ZTH'),
  'mietwagen-korsika': makeIslandSearchData('Korsika', 'BIA'),
  'mietwagen-la-palma': makeIslandSearchData('La Palma', 'SPC'),
  'mietwagen-sylt': makeIslandSearchData('Sylt', 'GWT'),
  'mietwagen-menorca': makeIslandSearchData('Menorca', 'MAH'),
  'mietwagen-la-gomera': makeIslandSearchData('La Gomera', 'GMZ'),
  'mietwagen-santorini': makeIslandSearchData('Santorini', 'JTR'),
  'mietwagen-bali': makeIslandSearchData('Denpasar-Bali', 'DPS'),
  'mietwagen-naxos': makeIslandSearchData('Naxos', 'JNX'),
  'mietwagen-formentera': makeIslandSearchData('Formentera', '0014Z'),
  'mietwagen-samos': makeIslandSearchData('Samos', 'SMI'),
  'mietwagen-koh-samui': makeIslandSearchData('Koh Samui', 'USM'),
  'mietwagen-thassos': makeIslandSearchData('Thasos', '0007T'),
  'mietwagen-mykonos': makeIslandSearchData('Mykonos', 'JMK'),
  'mietwagen-ruegen': makeIslandSearchData('Bergen auf Rügen', '0032H'),
  'mietwagen-elba': makeIslandSearchData('Elba', 'EBA'),
  'mietwagen-usedom': makeIslandSearchData('Heringsdorf', 'HDF'),
  'mietwagen-paros': makeIslandSearchData('Paros', 'PAS'),
  'mietwagen-mahe': makeIslandSearchData('Mahe', 'SEZ'),
  'mietwagen-fehmarn': makeIslandSearchData('Fehmarn', '001BH'),
  'mietwagen-milos': makeIslandSearchData('Milos', 'MLO'),
  'mietwagen-karpathos': makeIslandSearchData('Karpathos', 'AOK'),
  'mietwagen-djerba': makeIslandSearchData('Djerba', 'DJE'),
  'mietwagen-pico': makeIslandSearchData('Pico', 'PIX'),
  'mietwagen-el-hierro': makeIslandSearchData('El hierro', 'VDE'),
  'mietwagen-vancouver-island': makeIslandSearchData('Vancouver Island', 'YYJ'),
  'mietwagen-bornholm': makeIslandSearchData('Roenne - Bornholm', 'RNN'),
  'mietwagen-skopelos': makeIslandSearchData('Skopelos', '0007S'),
  'mietwagen-lesbos': makeIslandSearchData('Lesbos', 'MJT'),
  'mietwagen-langkawi': makeIslandSearchData('Langkawi', 'LGK'),
  'mietwagen-syrakus': makeIslandSearchData('Syracuse', 'CIY'),
  'mietwagen-oahu': makeIslandSearchData('Oahu', 'HNL'),
  'mietwagen-sifnos': makeIslandSearchData('Sifnos', '008BB'),
  'mietwagen-tinos': makeIslandSearchData('Tinos', '0030L'),
  'mietwagen-cala-mandia': makeIslandSearchData('Cala Mandia', '002ES'),
  'mietwagen-chios': makeIslandSearchData('Chios', 'JKH'),
  'mietwagen-flores': makeIslandSearchData('Flores', 'FLW'),
  'mietwagen-syros': makeIslandSearchData('Syros', 'JSY'),
  'mietwagen-cozumel': makeIslandSearchData('Cozumel', 'CZM'),
  'mietwagen-neufundland': makeIslandSearchData('Neufundland', 'YYT'),
  'mietwagen-kythira': makeIslandSearchData('Kithira', 'KIT'),
  'mietwagen-kauai-island': makeIslandSearchData('Kauai', 'LIH'),
};

export const ISLAND_PAGE_PATHS = Object.keys(ISLAND_STAGE_SEARCH_DATA).map(
  slug => `/${slug}.html`,
) as readonly string[];
